// Auto-generated at build time by scripts/generate-version.js.
// The committed value ("dev") is the local-development baseline; production
// builds overwrite this with the deployment timestamp.
export const VERSION: string = '1793746730363';
